import { gql } from '@apollo/client';

export const GET_STAFF_USERS = gql`
  query TournamentStaffList($clubSparkTournamentId: UUID!) {
    tournamentStaffList(clubSparkTournamentId: $clubSparkTournamentId) {
      id
      staffRoles
      email
      phone
      person {
        personId
        standardGivenName
        standardFamilyName
        uaid
      }
    }
  }
`;

export const GET_PERSON_BY_UAID_OR_EMAIL = gql`
  query GetPersonByUaidOrEmail($uaidOrEmail: String!, $legacyMode: Boolean) {
    personByUaidOrEmail(uaidOrEmail: $uaidOrEmail, legacyMode: $legacyMode) {
      uaid
      firstName
      lastName
      phone
      email
      safePlayStatus
    }
  }
`;

export const ADD_TOURNAMENT_ASSISTANTS = gql`
  mutation AddTournamentAssistant($clubSparkTournamentId: UUID!, $uaid: ID!, $legacyMode: Boolean) {
    addTournamentAssistant(clubSparkTournamentId: $clubSparkTournamentId, uaid: $uaid, legacyMode: $legacyMode) {
      id
      staffRoles
      email
      phone
      person {
        personId
        standardGivenName
        standardFamilyName
        uaid
      }
    }
  }
`;

export const REMOVE_TOURNAMENT_ASSISTANT = gql`
  mutation RemoveTournamentAssistant($clubSparkTournamentId: UUID!, $id: ID!) {
    removeTournamentAssistant(clubSparkTournamentId: $clubSparkTournamentId, id: $id) {
      id
      staffRoles
      email
      phone
      person {
        personId
        standardGivenName
        standardFamilyName
        uaid
      }
    }
  }
`;

export const SEND_STAFF_SMS = gql`
  mutation SendStaffSMS($tournamentId: UUID!, $staffId: ID!, $message: String!) {
    sendStaffSMS(tournamentId: $tournamentId, staffId: $staffId, message: $message)
  }
`;
